import { ElementWithFeedbackContainer } from './ElementWithFeedbackContainer';
import {
  FieldHeaderMapping,
  passThroughValue,
} from '@/app/features/products/common/components/frontend-processing/models';
import { Select, SelectProps } from '@ssar-app/uikit';
// import { debounce } from 'ts-debounce';
import { InputLabelsMap } from '@ssar-app/domain';

// const debouncedChangeFn = (
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   onChange: (...event: any[]) => void,
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
// ): ((...event: any[]) => void) => debounce(onChange, 300);

export interface FilteredSelectOption {
  value: string;
  label: string;
  priority?: number;
  hide?: boolean;
}

export interface FilteredSelectContainerProps extends SelectProps {
  options: FilteredSelectOption[];
}

export interface FilteredSelectProps {
  availableOptions: string[];
  inputLabelsMap: InputLabelsMap;
  selectedValue?: FieldHeaderMapping;
  errorMessage?: string;
  detectedHeaders: string[];
  onSelect: (
    value: FieldHeaderMapping,
    previousValue?: FieldHeaderMapping,
  ) => void;
}

const passThroughOption: FilteredSelectOption = {
  label: '[Pass Through]',
  value: passThroughValue,
};

export const FilteredSelect = (props: FilteredSelectProps) => {
  const {
    availableOptions,
    selectedValue,
    onSelect,
    errorMessage,
    inputLabelsMap,
  } = props;
  const getOptionByValue = (
    value?: string,
  ): FilteredSelectOption | undefined => {
    const entry = availableOptions.find((a) => a === value);
    if (entry) {
      return {
        label: entry,
        value: entry,
      };
    }
    return undefined;
  };

  const currentFieldHeaderData = selectedValue;
  const currentOptions: FilteredSelectOption[] = [];
  if (!currentFieldHeaderData?.experianHeader) {
    currentOptions.push({
      ...passThroughOption,
      hide: true,
      priority: -2,
    });
  } else {
    const option = getOptionByValue(currentFieldHeaderData?.experianHeader);
    if (option) {
      currentOptions.push(option);
    }
    currentOptions.push(passThroughOption);
  }

  // console.log('availableOptions: ', availableOptions);
  const finalAvailableOptions: FilteredSelectOption[] = availableOptions
    .filter(
      (a) => a.toLowerCase() !== selectedValue?.experianHeader?.toLowerCase(),
    )
    .map((a) => {
      const toReturn: FilteredSelectOption = {
        label: a,
        value: a,
      };
      return toReturn;
    })
    .concat(currentOptions)
    .map((a) => ({
      ...a,
      priority: a.priority
        ? a.priority
        : props.detectedHeaders.findIndex(
            (b) => b.toLowerCase() === a.label.toLowerCase(),
          ),
    }))
    .sort(
      (a, b) =>
        (a.priority === -1 ? props.detectedHeaders.length : a.priority) -
        (b.priority === -1 ? props.detectedHeaders.length : b.priority),
    );
  // console.log('finalAvailableOptions: ', finalAvailableOptions);
  return (
    <ElementWithFeedbackContainer
      messageContainerClassName='wide-tooltip'
      errors={errorMessage}
    >
      <Select
        placeholder='Select a field'
        onChange={(e) => {
          const value: FieldHeaderMapping =
            e.toString() === passThroughValue
              ? {
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  ...selectedValue!,
                  experianHeader: undefined,
                }
              : {
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  ...selectedValue!,
                  experianHeader: e.toString(),
                };
          setTimeout(() => {
            // console.log('Calling OnSelect');
            onSelect(value);
          });
        }}
        defaultValue={
          !currentFieldHeaderData?.experianHeader
            ? passThroughValue
            : currentFieldHeaderData?.experianHeader
        }
        options={finalAvailableOptions.map((entry) => {
          const tooltipContent =
            inputLabelsMap[entry.value?.toLowerCase()]?.description;
          const tooltipNode =
            tooltipContent && tooltipContent.length ? tooltipContent : null;
          return {
            label: entry.label,
            tooltip: tooltipNode,
            value: entry.value,
            hidden: entry.hide,
            key: entry.label,
          };
        })}
        selectContainerProps={{ width: 198 }}
        optionsProps={{ maxH: 64 }}
      />
    </ElementWithFeedbackContainer>
  );
};
